// extracted by mini-css-extract-plugin
export default {"layout":"LayoutLanding_layout__Izfxz"};